var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTv = function SvgTv(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M16.28 2.193a.6.6 0 0 1 .85.848l-3.683 3.682h6.083a2.483 2.483 0 0 1 2.482 2.483v10.353a2.483 2.483 0 0 1-2.483 2.482H4.47a2.483 2.483 0 0 1-2.482-2.482V9.206A2.48 2.48 0 0 1 4.47 6.723h6.08L6.868 3.041a.6.6 0 0 1 .848-.848l4.282 4.281zM4.47 7.923c-.708 0-1.283.574-1.283 1.283v10.353c0 .708.575 1.282 1.283 1.282h15.06c.707 0 1.281-.574 1.282-1.282V9.206c0-.708-.575-1.283-1.283-1.284H4.47"
  })));
};
export default SvgTv;